import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-user-activity-logs',
    templateUrl: './user-activity-logs.component.html',
    styleUrls: ['./user-activity-logs.component.scss'],
    standalone: false
})

/**
 * Analatics stat Component
 */
export class UserActivityLogs implements OnInit {

  @Input() activityLogs: any[] | undefined;
  @Input() totalActivityLogPages: number | undefined;

  @Output() onLoadMore: EventEmitter<any> = new EventEmitter<any>();

  page: number = 0;


  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

  /**
 * ngOnChanges
 * @param changes
 */
  ngOnChanges(changes: SimpleChanges) {
    //console.log(this.activityLogs)
  }

  /**
* Load More Function
*/
  loadMore() {
    this.page = this.page + 1;
    this.onLoadMore.emit({ page: this.page });
  }

}
